var _dec, _class, _class2, _temp;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { styled } from "../../theme";
import { TabIndicator } from "../shared/tabIndicator.component";
export
/**
 * A bar with tabs styled by Eva.
 * TabBar should contain Tab components to provide a useful navigation component.
 *
 * @extends React.Component
 *
 * @property {ReactElement<TabProps> | ReactElement<TabProps>[]} children - Tabs to be rendered within the bar.
 *
 * @property {number} selectedIndex - Index of currently selected tab.
 *
 * @property {(number) => void} onSelect - Called when tab is pressed.
 *
 * @property {StyleProp<ViewStyle>} indicatorStyle - Style of the indicator component.
 *
 * @property {ViewProps} ...ViewProps - Any props applied to View component.
 *
 * @overview-example TabBarSimpleUsage
 * In basic examples, tabs are wrapped within `TabBar`.
 *
 * @overview-example Using with React Navigation
 * TabBar can also be [configured with React Navigation](guides/configure-navigation)
 * to provide a navigational component.
 * ```
 * import React from 'react';
 * import { NavigationContainer } from '@react-navigation/native';
 * import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
 * import { TabBar, Tab, Layout, Text } from '../..';
 *
 * const { Navigator, Screen } = createBottomTabNavigator();
 *
 * const UsersScreen = () => (
 *   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
 *     <Text category='h1'>USERS</Text>
 *   </Layout>
 * );
 *
 * const OrdersScreen = () => (
 *   <Layout style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
 *     <Text category='h1'>ORDERS</Text>
 *   </Layout>
 * );
 *
 * const TopTabBar = ({ navigation, state }) => (
 *   <TabBar
 *     selectedIndex={state.index}
 *     onSelect={index => navigation.navigate(state.routeNames[index])}>
 *     <Tab title='USERS'/>
 *     <Tab title='ORDERS'/>
 *   </TabBar>
 * );
 *
 * const TabNavigator = () => (
 *   <Navigator tabBar={props => <TopTabBar {...props} />}>
 *     <Screen name='Users' component={UsersScreen}/>
 *     <Screen name='Orders' component={OrdersScreen}/>
 *   </Navigator>
 * );
 *
 * export const AppNavigator = () => (
 *   <NavigationContainer>
 *     <TabNavigator/>
 *   </NavigationContainer>
 * );
 * ```
 *
 * @overview-example TabBarAccessories
 * Tabs also may contain [icons](guides/icon-packages), to provide a better user interfaces.
 *
 * @overview-example TabStyling
 * Tab and it's inner views can be styled by passing them as function components.
 * ```
 * import { Tab, Text } from '../..';
 *
 * <Tab
 *   title={evaProps => <Text {...evaProps}>USERS</Text>}
 * />
 * ```
 *
 * @overview-example TabTheming
 * In most cases this is redundant, if [custom theme is configured](guides/branding).
 */
let TabBar = (_dec = styled('TabBar'), _dec(_class = (_temp = _class2 = class TabBar extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "tabIndicatorRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "onTabSelect", index => {
      this.props.onSelect && this.props.onSelect(index);
    });

    _defineProperty(this, "getComponentStyle", source => {
      const {
        indicatorHeight,
        indicatorBorderRadius,
        indicatorBackgroundColor
      } = source,
            containerParameters = _objectWithoutProperties(source, ["indicatorHeight", "indicatorBorderRadius", "indicatorBackgroundColor"]);

      return {
        container: containerParameters,
        item: {},
        indicator: {
          height: indicatorHeight,
          borderRadius: indicatorBorderRadius,
          backgroundColor: indicatorBackgroundColor
        }
      };
    });

    _defineProperty(this, "isTabSelected", index => {
      return index === this.props.selectedIndex;
    });

    _defineProperty(this, "renderTabElement", (element, index) => {
      return /*#__PURE__*/React.cloneElement(element, {
        key: index,
        style: [styles.item, element.props.style],
        selected: this.isTabSelected(index),
        onSelect: () => this.onTabSelect(index)
      });
    });

    _defineProperty(this, "renderTabElements", source => {
      return React.Children.map(source, this.renderTabElement);
    });
  }

  scrollToIndex(params) {
    var _this$tabIndicatorRef;

    (_this$tabIndicatorRef = this.tabIndicatorRef.current) === null || _this$tabIndicatorRef === void 0 ? void 0 : _this$tabIndicatorRef.scrollToIndex(params);
  }

  scrollToOffset(params) {
    var _this$tabIndicatorRef2;

    (_this$tabIndicatorRef2 = this.tabIndicatorRef.current) === null || _this$tabIndicatorRef2 === void 0 ? void 0 : _this$tabIndicatorRef2.scrollToOffset(params);
  }

  render() {
    const _this$props = this.props,
          {
      eva,
      style,
      indicatorStyle,
      selectedIndex,
      children
    } = _this$props,
          viewProps = _objectWithoutProperties(_this$props, ["eva", "style", "indicatorStyle", "selectedIndex", "children"]);

    const evaStyle = this.getComponentStyle(eva.style);
    const tabElements = this.renderTabElements(children);
    return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, _extends({}, viewProps, {
      style: [evaStyle.container, styles.container, style]
    }), tabElements), /*#__PURE__*/React.createElement(TabIndicator, {
      ref: this.tabIndicatorRef,
      style: [evaStyle.indicator, styles.indicator, indicatorStyle],
      selectedPosition: selectedIndex,
      positions: tabElements.length
    }));
  }

}, _defineProperty(_class2, "defaultProps", {
  selectedIndex: 0
}), _temp)) || _class);
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row'
  },
  item: {
    flex: 1
  },
  indicator: {}
});